var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  buildExpression: () => buildExpression
});
var import_core = __toModule(require("../../../../engine/math/core"));
var import_mathFunctionError = __toModule(require("../../../../error/mathFunctionError"));
var import_commutative = __toModule(require("./commutative"));
var import_double = __toModule(require("./double"));
var import_commutative2 = __toModule(require("./operator/commutative"));
var import_double2 = __toModule(require("./operator/double"));
var import_single = __toModule(require("./single"));
var import_triple = __toModule(require("./triple"));
const buildExpressionFunction = (operation, operands1, operands2) => {
  if ((0, import_commutative2.isCommutativeOperator)(operation)) {
    return (0, import_commutative2.buildCommutativeOperatorExpression)(operation, operands1, operands2);
  }
  if ((0, import_double2.isDoubleOperator)(operation)) {
    return (0, import_double2.buildDoubleOperatorExpression)(operation, operands1, operands2);
  }
  if ((0, import_single.isSingleExpression)(operation)) {
    return (0, import_single.buildSingleExpression)(operation, operands1, operands2);
  }
  if ((0, import_double.isDoubleExpression)(operation)) {
    return (0, import_double.buildDoubleExpression)(operation, operands1, operands2);
  }
  if ((0, import_triple.isTripleExpression)(operation)) {
    return (0, import_triple.buildTripleExpression)(operation, operands1, operands2);
  }
  if ((0, import_commutative.isCommutative)(operation)) {
    return (0, import_commutative.buildCommutativeExpression)(operation, operands1, operands2);
  }
  throw new import_mathFunctionError.MathFunctionError(`Unknown RITA operation ${operation}`);
};
const buildExpression = (operation, operands1, operands2, condition = []) => {
  const functionName = (0, import_core.translateFunction)(operation);
  if (!functionName) {
    throw new import_mathFunctionError.MathFunctionError(`Unknown airtable operation ${operation}`);
  }
  const expression = buildExpressionFunction(functionName, operands1, operands2);
  if (condition.length === 1) {
    return `ifThen(${condition}, ${expression})`;
  }
  return expression;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildExpression
});
